//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TalksMap from "@/utils/initMapTalks.js";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      popVisible: false, // 是否展示速度选择框
      speedIsActive: 1, // 选中的速度索引
      speedList: [
        {
          speedTimes: "0.5X",
          speed: 800,
        },
        {
          speedTimes: "1X",
          speed: 400,
        },
        {
          speedTimes: "2X",
          speed: 200,
        },
        {
          speedTimes: "3X",
          speed: 133,
        },
      ],
      info: [],
      trajectoryList: [],
      stopedIndex: 0, //?????
      calendarFlag: true, //????
      operationForPauseAndContinue: "start",
      kaishi: require("@/assets/start.png"),
      continueOrStopUrl: require("@/assets/start.png"),
      tingzhi: require("@/assets/stop.png"),

      iconStop: "icon-bofang",
      iconStart: "icon-zanting",
      palyBtnStatusClass: "icon-bofang",

      statusStatic: false,
    };
  },
  computed: {
    ...mapState("map", {
      trajectoryPlay: (state) => state.trajectoryPlay,
      handleName: (state) => state.kName,
    }),
  },
  watch: {
    trajectoryPlay: {
      handler: function (n) {
        if (n && n.show) {
          this.getTrajectoryPlayback(n.workId);
        }
      },
      deep: true,
      immediate: true,
    },
    handleName(newVal, oldVal) {
      if (newVal == "end") {
        this.operationForPauseAndContinue = "start";
        document.getElementById("pauseBtnsText").innerHTML = "开始";
        this.continueOrStopUrl = this.kaishi;
        this.calendarFlag = true;
      }
    },
  },
  mounted() {
    let this_ = this;
    this.getMapInit();
    this.TalksMapDialog.sendThis(this);
    document.addEventListener("click", function (e) {
      if (this_.popVisible === true) {
        this_.popVisible = false;
      }
    });
  },
  beforeDestroy() {
    //清除小车跑定时器
    if (this.TalksMapDialog._timer || this.TalksMapDialog.i > 0) {
      clearInterval(this.TalksMapDialog._timer);
      this.TalksMapDialog._timer = "";
    }
  },
  methods: {
    ...mapActions("map", ["changeTrajectoryPlay"]),
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("map", 16);
    },
    /**
     * @descripttion: 改变回放速度
     * @Author: juanjuanhui
     * @Date: 2021-12-09 17:25:02
     * @param {*} typeName 加速或减速
     */
    handleSpeedChange(typeName) {
      if (this.popVisible) {
        if (typeName == "slowdown") {
          this.speedIsActive =
            this.speedIsActive == 0 ? 0 : this.speedIsActive - 1;
        } else {
          let len = this.speedList.length - 1;
          this.speedIsActive =
            this.speedIsActive == len ? len : this.speedIsActive + 1;
        }
        this.speedNum = this.speedList[this.speedIsActive].speed;
        if (this.trajectoryList.length > 0) {
          this.TalksMapDialog.playBack(
            this.trajectoryList,
            typeName,
            this.stopedIndex,
            this.stopedIndex > 0,
            undefined,
            this.speedNum
          );
        }
      } else {
        this.popVisible = true;
      }
    },
    /**
     * @descripttion: 轨迹播放
     * @Author: juanjuanhui
     * @Date: 2021-12-09 17:38:42
     * @param {*} typeName
     * @param {*} index
     */
    handlePlay(typeName, index) {
      if (index || index === 0) {
        this.speedNum = this.speedList[index].speed;
      }
      if (document.getElementById("pauseBtns").innerHTML === "开始") {
        typeName = "start";
      }
      if (typeName === "start") {
        console.log(this);
        //开始
        let name_ = this.$store.state.map.kName;
        this.$store.state.map.kName = name_ ? "" : "start";
        this.stopedIndex = 0;
        this.calendarFlag = false;
        this.operationForPauseAndContinue = "pause";
        document.getElementById("starImg").src = require("@/assets/stop.png");
        this.continueOrStopUrl = this.tingzhi;
        this.speedNum = 400;
        this.speedIsActive = 1;
      } else if (typeName === "pause") {
        //停止
        this.stopedIndex = this.TalksMapDialog.i;
        this.operationForPauseAndContinue = "continue";
        document.getElementById("pauseBtns").innerHTML = "继续";
        this.continueOrStopUrl = this.kaishi;
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "continue") {
        //继续
        this.operationForPauseAndContinue = "pause";
        document.getElementById("pauseBtns").innerHTML = "停止";
        this.continueOrStopUrl = this.tingzhi;
        this.calendarFlag = false;
      } else if (typeName === "stop") {
        this.TalksMapDialog.lastLinePoints = [];
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "accelerate") {
        //加速减速
        this.speedIsActive = index;
        this.speedNum = this.speedList[index].speed;
      }
      if (this.trajectoryList.length > 0) {
        this.TalksMapDialog.playBack(
          this.trajectoryList,
          typeName,
          this.stopedIndex,
          this.stopedIndex > 0,
          undefined,
          this.speedNum
        );
      }
    },
    getTrajectoryPlayback(workId) {
      this.$http.work.getTrajectoryPlayback({ workId }).then((res) => {
        let { trackLinestring, ...data } = res.data;
        let trajectoryList = JSON.parse(trackLinestring);
        if (trackLinestring.length == 0) {
          return;
        }
        this.statusStatic = true;
        this.info = [data];
        this.trajectoryList = trajectoryList;
        let Coordinate = {
          x: trajectoryList[0][0],
          y: trajectoryList[0][1],
        };
        this.TalksMapDialog.map.setCenter(Coordinate);
        this.TalksMapDialog.drawLine(trajectoryList);
      });
    },
    /**
     * @descripttion: 退出轨迹播放
     * @Author: juanjuanhui
     * @Date: 2021-12-10 10:08:38
     * @param {*}
     * @return {*}
     */
    handleQuitTrajectoryPlay() {
      this.handlePlay("stop");
      this.changeTrajectoryPlay({ show: false, workId: "" });
    },
  },
};
